<template>
  <aside class="sidebar">
    <div class="sidebar-icon" @click="toggleSidebar">
      <div class="barr1"></div>
      <div class="barr2"></div>
      <div class="barr3"></div>
    </div>
    <div class="sidebar-icon close" @click="toggleSidebar">
      <div class="barr1"></div>
      <div class="barr2"></div>
      <div class="barr3"></div>
    </div>

    <ul class="sidebar-menu-set">
      <router-link to="/front/collectivites/dashboard">
        <div class="sidebar-menu-animate" :class="{ active: $route.name === 'collectivites-dashboard' }">
          <li class="sidebar-menu" :class="{ active: $route.name === 'collectivites-dashboard' }">
            <img src="/public/icons/icon-dashboard.svg" class="sidebar-menu-icon" alt="" />
            <span>Dashboard</span>
            <div class="my-badge br2 dot bg-color-warning"></div>
          </li>
        </div>
      </router-link>
      <router-link to="/front/collectivites/onboarding-groupe">
        <div class="sidebar-menu-animate" :class="{ active: $route.name === 'collectivites-onboarding-groupe' }">
          <li class="sidebar-menu" :class="{ active: $route.name === 'collectivites-onboarding-groupe' }">
            <img src="/public/icons/icon-onboarding-groupe.svg" class="sidebar-menu-icon" alt="" />
            <span>Onboarding groupé</span>
            <div class="my-badge br2 dot bg-color-notif"></div>
          </li>
        </div>
      </router-link>
      <router-link to="/front/collectivites">
        <div class="sidebar-menu-animate" :class="{ active: $route.name === 'collectivites' }">
          <li class="sidebar-menu" :class="{ active: $route.name === 'collectivites' }">
            <img src="/public/icons/icon-onboarding.svg" class="sidebar-menu-icon" alt="" />
            <span>Onboarding</span>
            <div class="my-badge br2 dot bg-color-notif"></div>
          </li>
        </div>
      </router-link>
      <router-link to="/front/collectivites/membres">
        <div class="sidebar-menu-animate" :class="{ active: $route.name === 'collectivites-membres' }">
          <li class="sidebar-menu" :class="{ active: $route.name === 'collectivites-membres' }">
            <img src="/public/icons/icon-collectivite.svg" class="sidebar-menu-icon" alt="" />
            <span>Gestion des membres</span>
            <div class="my-badge br2 dot bg-color-notif"></div>
          </li>
        </div>
      </router-link>
      <router-link to="/front/collectivites/recouvrement">
        <div class="sidebar-menu-animate" :class="{ active: $route.name === 'collectivites-recouvrement' }">
          <li class="sidebar-menu" :class="{ active: $route.name === 'collectivites-recouvrement' }">
            <img src="/public/icons/icon-recouvrement.svg" class="sidebar-menu-icon" alt="" />
            <span>Recouvrement</span>
            <div class="my-badge br2 dot bg-color-notif"></div>
          </li>
        </div>
      </router-link>
    </ul>
  </aside>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()

function toggleSidebar() {
  const sidebar = document.querySelector('.sidebar')
  if (sidebar) {
    sidebar.classList.toggle('close')
  }
}
</script>

<style scoped>
/* Les styles du sidebar sont gérés par les fichiers CSS globaux (user-ui.css, globals-coop-finance.css) */
.sidebar-menu-animate {
  cursor: pointer;
}
</style>

